// extracted by mini-css-extract-plugin
export default {"formLayout":"cQa6Twz18n"};